import { useState, useEffect } from "react";
import { get, put, post } from "../api";
import { QueryClient, useQuery, useMutation } from "@tanstack/react-query";

function useSearch() {
  const [state, setState] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [onlyPaid, setOnlyPaid] = useState("paid");
  const debounceValue = useDebounce(searchString, 500);

  const _searchQuery = useQuery({
    queryKey: ["search_results", debounceValue, onlyPaid],
    queryFn: async () =>
      await get(
        `/orders/search/${onlyPaid}/${
          debounceValue.length > 0 ? debounceValue : "null"
        }`
      ),
    onSuccess: (data) => setState(JSON.parse(data)),
    //enabled: debounceValue.length > 0,
  });
  return { state, searchString, setSearchString, onlyPaid, setOnlyPaid };
}
function useDebounce(cb, delay) {
  const [debounceValue, setDebounceValue] = useState(cb);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(cb);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [cb, delay]);
  return debounceValue;
}
export default useSearch;
